export const generalStyleDivs = {
    borderRadius: "30px",
    borderStyle: "solid",
    borderWidth: "2px",
    borderColor: "#8C6E63",
    backgroundColor: "rgba(248, 250, 245, 0.5)"
}